import client from '@/store/client'
import qs from 'query-string'
import { parseStringPromise } from 'xml2js'
import parseData from '../util/parsedata'


const getDefaultState = () => {
  return {
    ID: '',
    Name: '',
    TypeID: '',
    Revision: '',
    RowStatus: '1',
    LastUpdatedBy: '',
    LastUpdateDate: '',
    siteGroupAttachments: []
  }
}

export default {
  namespaced: true,
  state: {
    ...getDefaultState(),
    siteTypes: [],
    siteGroupSearch: '',
    siteSearchResults: [],
    totalOnServer: -1
  },
  actions: {
    SET_FIELD: ({ commit }, data) => {
      commit('setField', data)
    },
    RESET: ({ commit }) => {
      commit('reset')
    },
    GET_SITE_TYPES: async function({ commit }) {
      try{
        const APIRes = await client.post('/v1/Lookup.asmx/GetSiteGroupTypes', qs.stringify(this.getters['traceToken']))
        commit('setField', { key: 'siteTypes', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    FIND_SITE_GROUP: async function({ commit }, data) {
      try{
        const APIRes = await client.post('/v1/SiteGroup.asmx/FindSiteGroups', qs.stringify({...this.getters['siteGroup/searchData'], recordPerPageCount: data.itemsPerPage, recordIdx: data.page }))
        const response = await parseStringPromise(APIRes.data)
        commit('setSiteSearchResults', await parseData(APIRes.data))
        commit('setField', { key: 'totalOnServer', value: +response.content.collection[0].$.TotalRecordCount })

      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    GET_SITE_GROUP: async function({ commit }, data) {
      try{
        const APIRes = await client.post('/v1/SiteGroup.asmx/GetSiteGroup', qs.stringify({...this.getters['traceToken'], sitegroupID: data }))
        const response = await parseStringPromise(APIRes.data)
        commit('setCurrentSite', response.content.data[0].$)

      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    FIND_SITE_GROUP_ATTACHMENT: async function({ commit, state }) {
      try{
        const APIRes = await client.post('/v2/SiteGroup.asmx/FindSitesAttachments', qs.stringify({ siteGroupID: state.ID, siteGroupTypeID: state.TypeID }))
        commit('setField', { key: 'siteGroupAttachments', value: await parseData(APIRes.data) })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    INSERT_SITE_GROUP: async function() {
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Creating Site Group',
          subdetail: 'Please wait...',
        })
        const APIRes = await client.post('/v1/SiteGroup.asmx/InsertSiteGroup', qs.stringify(this.getters['siteGroup/insertData']))
        const parsedRes = await parseStringPromise(APIRes.data)
        await this.dispatch('siteGroup/GET_SITE_GROUP', parsedRes.content.data[0].$.ID)
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Site Group successfully created`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    UPDATE_SITE_GROUP: async function({state}) {
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating Site Group',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          name: state.Name,
          typeID: state.TypeID,
          ID: state.ID,
          revision: state.Revision
        }
        await client.post('/v1/SiteGroup.asmx/UpdateSiteGroup', qs.stringify(APIData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Site Group successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
    ATTACH_DETACH_SITE_GROUP: async function({state}, data) {
      try{
        this.dispatch('loader/CHANGE', {
          status: 'LOADING',
          detail: 'Updating',
          subdetail: 'Please wait...',
        })
        const APIData = {
          ...this.getters['traceToken'],
          ...data,
          siteGroupId: state.ID
        }
        await client.post('/v1/SiteGroup.asmx/AttachOrDetachSiteWithSitegroup ', qs.stringify(APIData))
        this.dispatch('loader/CHANGE', {
          status: 'COMPLETE',
          detail: 'Logging in',
          subdetail: '',
        })
        this.dispatch('ui/SET_TOAST', { message: `Site Group successfully updated`, color: 'green', delay: 2500 })
      }
      catch (err) {
        this.dispatch('loader/CHANGE', {
          status: 'ERROR',
          detail: 'Sorry, something went wrong.',
          subdetail: err.response.data,        
        })       
      }      
    },
  },
  getters: {
    siteGroupTypes: (state) => {
      return state.siteTypes.map( item => {
        return { text: item.Name, value: item.ID }
      })
    },
    searchData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        name: state.siteGroupSearch
      }
    },
    insertData: (state, getters, rootState, rootGetters) => {
      return {
        ...rootGetters['traceToken'],
        name: state.Name,
        typeID: state.TypeID
      }
    },
    attachedSiteGroups: state => {
      return state.siteGroupAttachments.map( item => {
        if (item.IsAttachedToSite == 'false') item.IsAttachedToSite = false
        else item.IsAttachedToSite = true 
        return item
      })
    },    
  },
  mutations: {
    setField: function(state, data) {
      state[data.key] = data.value
    },
    reset: function(state) {
      Object.assign(state, getDefaultState())
    },
    setSiteSearchResults: function( state, data ){
      state.siteSearchResults = data
    },
    setCurrentSite: function( state, data ){
      Object.keys(state).forEach(k => state[k] = data[k] || state[k])
    }
  },
}
